import { GetConstraintsResponse } from 'api/typegen/application/constraints/get';
import fetchWebApi from 'api/fetchWebApi';

const getConstraintsApiCall = async (): Promise<GetConstraintsResponse> =>
  fetchWebApi('/application/constraints');

export default getConstraintsApiCall;
